import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import despatchoService from "../../services/despatchoService";

export const fetchDespatcho=createAsyncThunk(
    "despatcho/fetch",
    async()=>{

        return await despatchoService.getDespatcho();

    }
);

export const removeDespatcho=createAsyncThunk(
    "despatcho/delete",
    async(id)=>{
        await despatchoService.deleteDespatcho(id);
        return id;
    }
);

export const addDespatcho = createAsyncThunk(
    "despatcho/add",
    async (formData, thunkAPI) => {
        try {
            return await despatchoService.addDespatcho(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const despatchoSlice=createSlice({

    name:"despatcho",

    initialState:{
        despatcho:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchDespatcho.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchDespatcho.fulfilled,(state,action)=>{
    state.loading=false;
    state.despatcho=action.payload;
})

.addCase(fetchDespatcho.rejected,(state)=>{
    state.loading=false;
})

.addCase(addDespatcho.fulfilled,(state,action)=>{

    state.despatcho.unshift(action.payload);

})

.addCase(removeDespatcho.fulfilled,(state,action)=>{

    state.despatcho=
    state.despatcho.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default despatchoSlice.reducer;